// extracted by mini-css-extract-plugin
export default {"monitorItem":"NoIssuesBlock_monitorItem__mmUwf","no_problems":"NoIssuesBlock_no_problems__sLwTa","colorGrey":"NoIssuesBlock_colorGrey__+wapN"};